import type { AccountBalance } from '@api/hooks/useBalance';
import { useBalance } from '@api/hooks/useBalance';
import { Carousel } from '@components/Carousel';
import { EmptyState } from '@components/EmptyState';
import { Loader } from '@gurupay/gp-ui-library';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AccountSlide } from './AccountSlide';

export const AccountCarousel: FC = () => {
	const { t } = useTranslation('', { keyPrefix: 'totalBalance' });
	const { data, isLoading } = useBalance({});

	return (
		<Carousel<AccountBalance>
			emptySlot={
				<div className="py-space-32">
					<EmptyState
						subTitle={t('noAccountsDescription')}
						title={t('noAccountsTitle')}
					/>
				</div>
			}
			isLoading={isLoading}
			items={data?.items ?? []}
			loadingSlot={
				<div className="flex flex-col justify-center items-center gap-y-space-16 py-space-32">
					<Loader />
					{t('fetchingData')}
				</div>
			}
			renderSlide={(account) => <AccountSlide balance={account} />}
		/>
	);
};
